import CryptoJS from 'crypto-js';

export const CryptoUtility = {
  getEncryptedText(inputMessage, Constants) {
    if (inputMessage) {
      let key = this.getBase64DecodedValue(Constants.CryptoVariables.DecisionMaker);
      let ivHex = this.getBase64DecodedValue(Constants.CryptoVariables.Supporter);

      key = CryptoJS.enc.Utf8.parse(key);
      const encryptionKeyArray = this.getHashedKey(key);

      const options = {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: CryptoJS.enc.Utf8.parse(ivHex)
      };

      const textWordArray = CryptoJS.enc.Utf8.parse(inputMessage);
      const encrypted = CryptoJS.AES.encrypt(textWordArray, encryptionKeyArray, options);
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext).replace(/[+]/g, '..');
    }
  },

  getDecryptedText(inputMessage, Constants) {
    if (inputMessage) {
      inputMessage = inputMessage.split("..").join("+").replace(/[ ]+/g, '');
      let key = this.getBase64DecodedValue(Constants.CryptoVariables.DecisionMaker);
      let ivHex = this.getBase64DecodedValue(Constants.CryptoVariables.Supporter);

      key = CryptoJS.enc.Utf8.parse(key);
      const encryptionKeyArray = this.getHashedKey(key);

      const options = {
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        iv: CryptoJS.enc.Utf8.parse(ivHex)
      };

      const parsedWordArray = CryptoJS.enc.Base64.parse(inputMessage);
      const decrypted = CryptoJS.AES.decrypt({ ciphertext: parsedWordArray }, encryptionKeyArray, options);
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  },

  getBase64DecodedValue(inputValue) {
    if (inputValue) {
      const parsedWordArray = CryptoJS.enc.Base64.parse(inputValue);
      return parsedWordArray.toString(CryptoJS.enc.Utf8);
    }
  },

  getHashedKey(inputKey) {
    if (inputKey) {
      return CryptoJS.SHA256(inputKey);
    }
  }
};